import Tooltip from 'rc-tooltip';
// import 'rc-tooltip/assets/bootstrap.css';
import * as React from 'react';
import { CategoryHotels } from '../core/CategoryHotels';
import { NavLink } from 'react-router-dom';
import Slider from 'react-slick';
import { BaseComponent } from '../base/BaseComponent';
import { FormatterUtils, getHotelSlug, LOCAL_STORAGE_KEY_WISHLIST, SESSION_STORAGE_BOOKING, BHAM_STORAGE_WISHLIST } from '../core/Const';
import { makeid, TRIPADVISOR, ModalWrapper } from '../core/index';
import { WishlistStorageData } from '../header/WishList';
import { HotelBedData } from '../shared/HotelBedData';
import { HotelBedCatalogData } from '../shared/index';
import { getAjaxhelper } from '../utils/CoreAjaxHelper';
import { isNull, makeIsoDate, momentWrapper, momentDuration, appendTranslations } from '../utils/index';
import { RecieveHotelDetailDataControlManager } from './hotel-common-utils';
import { HotelListPanelProps, HotelListPanelState, WishlistRequest } from './HotelListPanel';
import { RoomAvailabilityList } from './RoomAvailabilityList';
import { HotelDescription } from './details/HotelDescription';
import { HotelImages } from './details/HotelImages';
import { HotelMounthlySpecial } from './details/HotelMounthlySpecial';
import { HotelMap } from './details/HotelMap';

export interface HotelListPanelWithBulkDataProps extends HotelListPanelProps {
    /**
     * manager revieve data hotel detail. untuk push data hotel detail
     */
    recieveHotelDetailDataControlManager: RecieveHotelDetailDataControlManager;
    /**
     * data category di index
     */
    indexedCategoryData: { [id: string]: HotelBedCatalogData.Category };
    firebaseApp: firebase.app.App;
}
export interface HotelListPanelWithBulkDataState extends HotelListPanelState {
    minPrice: number;
    discountVal: number;
    boardName: string;
    hotelDatas: any;
    atLowerPrice: 'TRUE' | 'FALSE';
    oneDolarDeposit: 'TRUE' | 'FALSE';
    showRoomDetail: boolean;
    showRoomDetailText: string;
    imgThumbs: string[];
    showDetail: 'roomdetail' | 'map' | 'image' | 'descrition' | 'review' | 'special' | 'price' | '';
}

export class HotelListPanelWithBulkData extends BaseComponent<HotelListPanelWithBulkDataProps, HotelListPanelWithBulkDataState> {
    topDiv: any;
    /**
     * id dari data hotel register. ke dalam manager
     */
    hotelDetailDataRegisterId: string;
    btnOption: any;
    constructor(props: HotelListPanelWithBulkDataProps) {
        super(props);
        let textPromoLine = '';
        let classPromoLine = 'hide';
        let classHaveoffer = 'hide';
        let classHotels = '';
        // this._gapi = google.maps.Map;
        if (props.hotelData.special!.length > 0) {
            textPromoLine = props.hotelData.special!;
            classHaveoffer = '';
            classPromoLine = '';
            if (props.hotelData.discount! > 0) {
                classHotels = 'offers';
            }
        }
        let btnWishlist = (
            <button
                className='btn btn-o btn-danger form-control btn-wishlist'
                type='button'
                onClick={() => {
                    this.wishlist(this.props.hotelData);
                }}
            >
                <i className="fa fa-heart wishlist-mobile" style={{ color: 'red' }} /> <span className="desktop-only">Wish List</span>
            </button>
        );
        this.state = {
            hotelData: props.hotelData,
            image_url: '',
            currency: '',
            images: props.hotelData.images,
            imgThumbs: props.hotelData.img_thumb!,
            isOpen: false,
            classHaveoffer: classHaveoffer,
            offerRate: 0,
            classHotels: classHotels,
            classPromoLine: classPromoLine,
            newRate: {},
            textPromoLine: textPromoLine,
            classright: '',
            // RoomsVailable: [],
            showAll: true, minPrice: props.hotelData.minRate!, discountVal: props.hotelData.discount!,
            atLowerPrice: props.hotelData.arLowerPrice!, oneDolarDeposit: props.hotelData.oneDolarDeposit!,
            roomDetailOpen: false,
            iconPlus: <i className="fa fa-plus-square-o" />,
            roomDetail: <span />,
            hotelDesriptionClass: 'short-description',
            btnClickNoteText: 'Read More',
            boardName: '',
            btnWishlist: btnWishlist,
            wishlistAnimeClass: 'hide',
            tripAdvisorData: props.hotelData.tripAdvisor,
            tripmodelOpen: false,
            hotelDatas: this.renderHtPriceMobile('hide', btnWishlist, false, 'Choose Rooms', 'price'),
            showRoomDetail: false,
            showRoomDetailText: 'Choose Rooms',
            showDetail: 'price'
        };
    }
    componentDidMount() {
        if (super.componentDidMount) {
            super.componentDidMount();
        }
        this.hotelDetailDataRegisterId = this.props.recieveHotelDetailDataControlManager.registerHandler(this.props.hotelId, this.onHotelDetailDataRecevied);
        // this.btnOption.click();
        /**
         * Augomatic Show Rooms
         */
        /*
        let night = '';
        if (!isNull(this.props.initialFilter) && !isNull(this.props.initialFilter.stay)) {
            let checkIn = this.props.initialFilter.stay!.checkIn;
            let checkOut = this.props.initialFilter.stay!.checkOut;
            if (typeof checkIn === 'string') {
                checkIn = momentWrapper(checkIn);
            }
            if (typeof checkOut === 'string') {
                checkOut = momentWrapper(checkOut);
            }
            night = momentDuration(checkOut.diff(checkIn)).as('day').toFixed(0);
        }
        this.setState({
            hotelDatas: <RoomAvailabilityList key={`RoomAvailabilityList${this.state.hotelData.reqAvailableDetailId!}`} lang={this.props.lang} reqKey={this.props.responKey} firebaseApp={this.props.firebaseApp} classright={this.state.classright} night={night} currencyCode={this.props.currency} reqAvailableDetailId={this.state.hotelData.reqAvailableDetailId!} history={this.props.history} />,
            showRoomDetailText: 'Hide Options',
            showRoomDetail: true, showDetail: 'roomdetail'
        });
        */
        /**
         * End of Automatic show Rooms
         */

    }
    componentWillUnmount() {
        if (super.componentWillUnmount) {
            super.componentWillUnmount();
        }
        if (this.hotelDetailDataRegisterId) {
            this.props.recieveHotelDetailDataControlManager.unregisterHandler(this.hotelDetailDataRegisterId);
        }

    }

    showRoomDetail: (roomId: string) => any = (roomId: string) => {
        this.setStateHelper(
            st => {
                st.roomDetailOpen = true;
                //             st.roomToOpen = room;
            });
    }

    booking: (rates: any[]) => any = (rates: any[]) => {
        let st = {
            hotelData: this.props.hotelData,
            rates: rates,
            stay: {
                checkIn: makeIsoDate(new Date(this.props.initialFilter.stay!.checkIn)),
                checkOut: makeIsoDate(new Date(this.props.initialFilter.stay!.checkOut))
            }
        };
        window['HotelListPanel'] = st;
        sessionStorage.setItem(SESSION_STORAGE_BOOKING, JSON.stringify(st));

        this.props.history.push(`/booking?rk=${this.props.responKey}`);
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let hotelData = this.state.hotelData;
        let style: ReactModal.Styles = {
            overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0, 0.75)', zIndex: 9999 },
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                overflow: 'hidden',
                backgroundColor: 'rgba(0,0,0,0)',
                border: 0
            }
        };

        let settings = {
            dots: false,
            infinite: true,
            speed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            pauseOnHover: true,
            fade: false
        };
        let slide: any[] = [];
        let x = 1;
        if (!isNull(this.state.images)) {
            for (let image of this.state.images as HotelBedData.Image[]) {
                slide.push(

                    <div key={makeid()} className='hotel-image-slider'>
                        <div className="popup-hotelimage" style={{ backgroundImage: `url("${image.path}")`, width: '100%', backgroundSize: 'cover' }}> <div className="container home-banner" /></div>
                    </div>
                );
                x++;
            }
        }
        // let offerAndNet = (this.state.newRate.net as any / 1) - this.state.offerRate;
        // let percent = (this.state.offerRate / offerAndNet * 100 * -1).toFixed(0);
        let hotelSlug = getHotelSlug(hotelData.name!, hotelData.code!);
        let hotelImageSlideComp = <span />;
        let hotelImageSlide = [];
        let hotelimages: string[] = [];
        x = 0;
        if (!isNull(this.state.images)) {
            for (let image of this.state.images as HotelBedData.Image[]) {
                if (x < 6) {
                    hotelimages.push(`${image.thumb}`);
                    hotelImageSlide.push(
                        <div key={makeid()}>
                            <div
                                className="hotel-image"
                                style={{ height: '210px', backgroundImage: `url("${image.thumb}")`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            > <span style={{ fontSize: '1px' }} > https://www.balihotelsandmore.com</span>
                            </div>
                        </div>
                    );
                    x++;
                } else {
                    break;
                }

            }
        }

        var settingshtimage = {
            dots: true,
            dotsClass: "slick-dots slick-thumb",
            infinite: true,
            speed: 2000,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            pauseOnHover: true,
            autoplaySpeed: 5000,
            customPaging: (i: any) => {
                return (
                    <a>
                        <img style={{ width: 40, height: 40 }} src={`${hotelimages[i]}`} />
                    </a>
                );
            },
        };
        hotelImageSlideComp = (
            <div
                onClick={() => {
                    this.setStateHelper(st => st.isOpen = true);
                }}
            >
                <Slider {...settingshtimage}>
                    {hotelImageSlide}
                </Slider>
            </div>

        );
        if (hotelImageSlide.length === 0) {
            hotelImageSlideComp = <div style={{ background: 'url(/assets/images/no-image.jpg)', borderRadius: '0 0 0 5px', backgroundPosition: 'center', backgroundSize: 'cover', width: '100%', height: 260 }}> {} </div>;
        }
        let night = '';
        if (!isNull(this.props.initialFilter) && !isNull(this.props.initialFilter.stay)) {
            let checkIn = this.props.initialFilter.stay!.checkIn;
            let checkOut = this.props.initialFilter.stay!.checkOut;
            if (typeof checkIn === 'string') {
                checkIn = momentWrapper(checkIn);
            }
            if (typeof checkOut === 'string') {
                checkOut = momentWrapper(checkOut);
            }
            night = momentDuration(checkOut.diff(checkIn)).as('day').toFixed(0);
        }
        let tripadvisor = <span />;

        if (!isNull(this.state.tripAdvisorData)) {
            let rangked = '';
            if (!isNull(this.state.tripAdvisorData.ranking_data) && !isNull(this.state.tripAdvisorData.ranking_data.ranking_string)) {
                rangked = this.state.tripAdvisorData.ranking_data.ranking_string;
            }
            let isiToolTip = [];
            if (!isNull(this.state.tripAdvisorData) && !isNull(this.state.tripAdvisorData.subratings) && this.state.tripAdvisorData.subratings.length > 0) {
                for (let subrating of this.state.tripAdvisorData.subratings) {
                    isiToolTip.push(
                        <p key={makeid()} >{subrating.localized_name} :  <img src={subrating.rating_image_url} /> </p>
                    );
                }
            }
            tripadvisor = (
                <div>
                    <p key={1}>
                        <Tooltip
                            placement='bottom'
                            overlay={<div style={{ minHeight: 50, minWidth: 50 }}> {isiToolTip} </div>}
                        >
                            <a
                                onClick={
                                    () => {
                                        this.setState({ tripmodelOpen: true });
                                    }
                                }
                            >
                                TripAdvisor Traveller Rating<br />
                                <img src={this.state.tripAdvisorData.rating_image_url ? this.state.tripAdvisorData.rating_image_url!.split('http:').join('https:') : ''} style={{ width: 100 }} /> <span style={{ fontSize: 10 }}>Base on {this.state.tripAdvisorData.num_reviews} reviews </span>
                            </a>
                        </Tooltip>
                    </p>
                    <p key={2}>
                        <span className="btn-purple" style={{ padding: '2px 5px' }}>
                            Ranked : {rangked}
                        </span>
                    </p>
                </div>
            );

        }
        let hotelDatas = this.state.hotelDatas;
        let isiRateCommend = [];

        let getCmsContent: (x2: any) => any = (x2: any) => {
            return { __html: x2 };
        };

        if (!isNull(this.state.hotelData) && !isNull(this.state.hotelData.rateComments) && this.state.hotelData.rateComments!.length > 0) {
            let idxRateCommDesc: { [id: string]: HotelBedCatalogData.RateComment } = {};
            for (let com of this.state.hotelData.rateComments!) {
                if (isNull(idxRateCommDesc[com.dateStart + '-' + com.dateEnd + '-' + com.description])) {
                    idxRateCommDesc[com.dateStart + '-' + com.dateEnd + '-' + com.description] = {};
                }
                idxRateCommDesc[com.dateStart + '-' + com.dateEnd + '-' + com.description] = com;
            }
            for (let a of Object.keys(idxRateCommDesc)) {
                let rateComment = idxRateCommDesc[a];
                let dateFrom = <span />;
                let dateEnd = <span />;
                let masuk = 0;
                if (!isNull(rateComment.dateStart)) {
                    dateFrom = <span>From {rateComment.dateStart} </span>;
                    masuk = 1;
                }
                if (!isNull(rateComment.dateEnd)) {
                    dateEnd = <span> Until {rateComment.dateEnd} </span>;
                    masuk = 1;
                }
                if (masuk === 1) {
                    isiRateCommend.push(
                        <p key={makeid()} >{dateFrom} {dateEnd}</p>
                    );
                }
                isiRateCommend.push(
                    <p key={makeid()} dangerouslySetInnerHTML={getCmsContent(rateComment.description)} />
                );
                // adarateCommend = 1;
            }
        }

        const { cssDisc, total, priceStyle, adult, room, child } = this.calculatePrice();
        let htPrice = (
            <div className='hotel-price' >

                <div className={`curent`} style={{ textDecoration: 'line-through', color: '#d20300' }} >
                    <span className={cssDisc}>  {new FormatterUtils().formatMoney(total, this.props.currency, true, false)}</span>
                </div>
                <p className={`center ${this.state.classright} price`} style={priceStyle}>
                    {new FormatterUtils().formatMoney(this.props.hotelData.minRate!, this.props.currency, true, false)}
                    <span style={{ display: 'block', fontSize: 12 }}>{room > 1 ? 'Lowest Price Option Per Room' : ''} </span>
                </p>
                <p className={`center ${this.state.classright}`} style={{ fontSize: 18, color: '#444' }} >  {room} <i className='fa fa-bed' style={{ color: 'rgba(170, 0, 187, 0.74)' }} /> {adult} <i className='fa fa-user' style={{ color: 'rgba(170, 0, 187, 0.74)' }} />  {child} <i className='fa fa-child' style={{ color: 'rgba(170, 0, 187, 0.74)' }} />
                    <br /> <span style={{ fontSize: 12 }}>{this.props.hotelData.minPriceBoard} </span>
                </p>

                {this.state.btnWishlist}
                <i className={`fa fa-heart jantung ${this.state.wishlistAnimeClass}`} style={{ color: 'red', fontSize: 75 }} />

            </div>
        );

        if (this.state.minPrice === 10000000000) {
            htPrice = (
                <div className='hotel-price' >
                    <i className="ti-alarm-clock" style={{ fontSize: 72, color: '#ff0000' }} /> <br />
                    <h4 style={{ color: '#ff0000' }}><strong>You missed this deal <i className="ti-face-sad" /></strong><br /> These dates are really popular in Bali! </h4>
                </div>
            );

        }

        return (
            <div className={`col-md-12 row nopadding hotel-list ${this.state.classHotels}`} ref={d => this.topDiv = d}>
                <div className={`${this.state.classPromoLine} ${this.state.classHotels}`} >
                    <span style={{ padding: '0 20px', textAlign: 'left', width: '100%', display: 'block' }}>
                        {this.state.textPromoLine}
                        {this.props.hotelData && this.props.hotelData.discount ? <span className="desktop-only" style={{ float: "right" }}>Save upto {this.props.hotelData.discount}% </span> : ""}
                    </span>
                </div>
                <div className="col-md-4 nopadding">
                    {hotelImageSlideComp}
                </div>
                <div className="col-md-5 hotel-content" style={{ margin: '10px 0', position: 'relative', height: 240 }}>
                    
                    <h4> <NavLink to={`${hotelSlug}?rk=${this.props.responKey}&reqaid=${hotelData.reqAvailableDetailId}&night=${night}`} target="_blank" > {hotelData.name} <i className='fa fa-info-circle' /> </NavLink> </h4>
                    <div>
                        <CategoryHotels
                            key={'stars'}
                            star={this.props.hotelData.star!}
                        />
                        <a key={'loc'} href={`/maps?rk=${this.props.responKey}&id=${hotelData.code}`} target="_blank" style={{ float: 'right', color: '#4f00ff', fontSize: 14 }}>
                            <i className="fa fa-map-marker" />{` ${hotelData.zoneName}`} - View on map
                        </a>
                        {tripadvisor}
                        <a href="http://baliholidaysandmorevip.com" style={{ lineHeight: '20px', display: 'block' }} target="_blank"><i className="fa fa-diamond" style={{ fontSize: 20, width: 30, float: 'left' }} /> <span style={{ color: 'rgb(158, 126, 0)', fontWeight: 800 }}>Get Bali VIP With This Booking </span> <i className="fa fa-asterisk" style={{ color: '#ff0000' }} /></a>
                        <a style={{ lineHeight: '20px', display: 'block' }} target="_blank" href="https://wa.me/+6287860006919&text=Hallo%20Bali%20hotels"><i className="fa fa-whatsapp" style={{ fontSize: 20, width: 30, float: 'left' }} /> <span style={{}}>Need Help? We Live In Bali! Click Here For Help.</span>  </a>
                        {this.state.oneDolarDeposit === 'TRUE' ? <span style={{ display: 'block' }}><i className="fa fa-money" style={{ fontSize: 20, width: 30, float: 'left' }} /> <span style={{}}>Book Room For $1 Deposit Is Available</span></span> : <span />}
                    </div>
                    <div className="btn-group btn-group-justified btn-hotel-detail" style={{ marginLeft: '-15px', top: this.props.hotelData && this.props.hotelData.discount ? '200px' : '198px', width: 'calc(100%)', position: 'absolute' }}>
                        <div
                            className={`btn-group btn show-on-mobile   ${this.state.showDetail === 'price' ? 'btn-info' : 'btn-primary'}`}
                            style={{ textAlign: 'center', padding: 2, borderRadius: 0 }}
                            onClick={
                                () => {
                                    this.setState({
                                        showDetail: 'price',
                                        hotelDatas: this.renderHtPriceMobile(this.state.wishlistAnimeClass, this.state.btnWishlist, this.state.showRoomDetail, this.state.showRoomDetailText, this.state.showDetail),
                                        showRoomDetail: false
                                    });
                                }
                            }
                        >
                            <a href={`javascript:void(0)`} style={{ textAlign: 'center', color: '#fff' }}  >
                                <i className="ti-shopping-cart" style={{ fontSize: 22 }} /><br />
                                Price
                            </a>
                        </div>
                        <div
                            className={`btn-group btn ${this.state.showDetail === 'map' ? 'btn-info' : 'btn-primary'}`}
                            style={{ textAlign: 'center', padding: 2, borderRadius: 0 }}
                            onClick={
                                () => {
                                    if (this.state.showDetail === 'map') {
                                        this.setState({
                                            showDetail: 'price',
                                            hotelDatas: this.renderHtPriceMobile(this.state.wishlistAnimeClass, this.state.btnWishlist, this.state.showRoomDetail, this.state.showRoomDetailText, this.state.showDetail),
                                            showRoomDetail: false
                                        });
                                    } else {
                                        this.setState({
                                            showDetail: 'map',
                                            hotelDatas: this.renderHotelMap(),
                                            showRoomDetail: false
                                        });
                                    }

                                }
                            }
                        >
                            <a href={`javascript:void(0)`} style={{ textAlign: 'center', color: '#fff' }} >
                                <i className="ti-map-alt" style={{ fontSize: 22 }} /><br />
                                Map
                            </a>
                        </div>
                        <div
                            className={`btn-group btn desktop-only ${this.state.showDetail === 'image' ? 'btn-info' : 'btn-primary'}`}
                            style={{ textAlign: 'center', padding: 2, borderRadius: 0 }}
                            onClick={
                                () => {
                                    if (this.state.showDetail === 'image') {
                                        this.setState({
                                            showDetail: 'price',
                                            hotelDatas: this.renderHtPriceMobile(this.state.wishlistAnimeClass, this.state.btnWishlist, this.state.showRoomDetail, this.state.showRoomDetailText, this.state.showDetail),
                                            showRoomDetail: false
                                        });
                                    } else {
                                        this.setState({
                                            showDetail: 'image',
                                            hotelDatas: this.renderHotelImage(),
                                            showRoomDetail: false
                                        });
                                    }
                                }
                            }
                        >
                            <a href={`javascript:void(0)`} style={{ textAlign: 'center', color: '#fff' }}   >
                                <i className="ti-image" style={{ fontSize: 22 }} /><br />
                                Image
                            </a>
                        </div>
                        <div
                            className={`btn-group btn ${this.state.showDetail === 'descrition' ? 'btn-info' : 'btn-primary'}`}
                            style={{ textAlign: 'center', padding: 2, borderRadius: 0 }}
                            onClick={
                                () => {
                                    if (this.state.showDetail === 'descrition') {
                                        this.setState({
                                            showDetail: 'price',
                                            hotelDatas: this.renderHtPriceMobile(this.state.wishlistAnimeClass, this.state.btnWishlist, this.state.showRoomDetail, this.state.showRoomDetailText, this.state.showDetail),
                                            showRoomDetail: false
                                        });
                                    } else {
                                        this.setState({
                                            showDetail: 'descrition',
                                            hotelDatas: this.renderHotelDetail(),
                                            showRoomDetail: false
                                        });
                                    }
                                }
                            }
                        >
                            <a href={`javascript:void(0)`} style={{ textAlign: 'center', color: '#fff' }}   >
                                <i className="ti-agenda" style={{ fontSize: 22 }} /><br />
                                Detail
                            </a>
                        </div>
                        <div
                            className={`btn-group btn ${this.state.showDetail === 'review' ? 'btn-info' : 'btn-primary'}`}
                            style={{ textAlign: 'center', padding: 2, borderRadius: 0 }}
                            onClick={
                                () => {
                                    if (this.state.showDetail === 'review') {
                                        this.setState({
                                            showDetail: 'price',
                                            hotelDatas: this.renderHtPriceMobile(this.state.wishlistAnimeClass, this.state.btnWishlist, this.state.showRoomDetail, this.state.showRoomDetailText, this.state.showDetail),
                                            showRoomDetail: false
                                        });
                                    } else {
                                        this.setState({
                                            showDetail: 'review',
                                            hotelDatas: this.renderHotelReview(),
                                            showRoomDetail: false
                                        });
                                    }
                                }
                            }
                        >
                            <a href={`javascript:void(0)`} style={{ textAlign: 'center', color: '#fff' }}   >
                                <span style={{width: '100%', textAlign: 'center'}}><img src="https://storage.googleapis.com/bali-hotel-images/tipadvisor.png"/></span>
                                <br />
                                Review
                            </a>
                        </div>
                        <div
                            className={`btn-group btn ${this.state.showDetail === 'special' ? 'btn-info' : 'btn-primary'}`}
                            style={{ textAlign: 'center', padding: 2, borderRadius: 0 }}
                            onClick={
                                () => {
                                    if (this.state.showDetail === 'special') {
                                        this.setState({
                                            showDetail: 'price',
                                            hotelDatas: this.renderHtPriceMobile(this.state.wishlistAnimeClass, this.state.btnWishlist, this.state.showRoomDetail, this.state.showRoomDetailText, this.state.showDetail),
                                            showRoomDetail: false
                                        });
                                    } else {
                                        this.setState({
                                            showDetail: 'special',
                                            hotelDatas: this.renderMounthlySpecial(),
                                            showRoomDetail: false
                                        });
                                    }
                                }
                            }
                        >
                            <a href={`javascript:void(0)`} style={{ textAlign: 'center', color: '#fff' }}   >
                                <i className="ti-medall" style={{ fontSize: 22 }} /><br />
                                Special
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 nopadding" style={{ position: 'relative' }}>
                    {htPrice}
                    <button
                        className={`btn-group btn form-control desktop-only ${this.state.showDetail === 'roomdetail' ? 'btn-info' : 'btn-danger'}`}
                        style={{ marginTop: '5px', position: 'absolute', bottom: 0, borderRadius: 0, height: 52 }}
                        onClick={
                            () => {
                                console.log("Button di click");
                                let showRoomDetail = !this.state.showRoomDetail;
                                if (showRoomDetail) {
                                    this.setState(
                                        {
                                            hotelDatas: <RoomAvailabilityList key={`RoomAvailabilityList${this.state.hotelData.reqAvailableDetailId!}`} lang={this.props.lang} reqKey={this.props.responKey} firebaseApp={this.props.firebaseApp} classright={this.state.classright} night={night} currencyCode={this.props.currency} reqAvailableDetailId={this.state.hotelData.reqAvailableDetailId!} history={this.props.history} />,
                                            showRoomDetailText: 'Hide Options',
                                            showRoomDetail, showDetail: 'roomdetail'
                                        }
                                    );
                                } else if (this.state.showDetail === 'roomdetail') {
                                    this.setState(
                                        {
                                            hotelDatas: <span />,
                                            showRoomDetailText: 'Choose Rooms',
                                            showRoomDetail, showDetail: 'price'
                                        }
                                    );
                                }

                            }
                        }
                    >
                        {this.state.showRoomDetailText}
                    </button>
                </div>
                {hotelDatas}
                <ModalWrapper
                    style={style}
                    isOpen={this.state.isOpen}
                    onRequestClose={this.hengleUserDialogClose}
                    role="dialog"
                    contentLabel="Minimal Modal Example"
                >
                    <div className="show-popup-detail">
                        <button
                            className="btnClose2"
                            onClick={
                                () => {
                                    this.setState({ isOpen: false });
                                }
                            }
                        >
                            <i className="ti-close" />
                        </button>
                        <Slider {...settings}>
                            {slide}
                        </Slider>
                    </div>
                </ModalWrapper>
                <ModalWrapper
                    style={style}
                    isOpen={this.state.tripmodelOpen}
                    onRequestClose={this.tripModelClosDialog}
                    role="dialog"
                    contentLabel="Minimal Modal Example"
                >
                    <div className="show-room-detail" >
                        <iframe style={{ width: '100vh', height: '100vh' }} src={`${TRIPADVISOR.WidgetEmbed}${this.props.hotelId}`} />
                    </div>
                </ModalWrapper>
            </div>
        );
    }

    calculatePrice = () => {
        let cssDisc = 'hide';
        // let minPrice = 0;
        let total = 0;
        let priceStyle: any = { marginTop: 30 };
        if (this.props.hotelData.minRateDiscount! < 0) {
            // minPrice = this.state.minPrice;
            if (this.state.discountVal !== 0) {
                cssDisc = '';
                total = this.props.hotelData.minRate! - this.props.hotelData.minRateDiscount!;
                priceStyle = {};
            }
        }
        let adult = 0;
        let room = 0;
        let child = 0;
        if (this.props.initialFilter && this.props.initialFilter.occupancies && this.props.initialFilter.occupancies.length > 0) {
            for (let oc of this.props.initialFilter.occupancies!) {
                adult += oc.adults!;
                room++;
                child += oc.children!;
            }
        }
        return { cssDisc, total, priceStyle, adult, room, child };
    }

    renderHtPriceMobile = (wishlistAnimeClass: string, btnWishlist: any, showRoomDetailstatu: boolean, showRoomDetailText: string, showDetail: 'roomdetail' | 'map' | 'image' | 'descrition' | 'review' | 'special' | 'price' | '') => {
        const { cssDisc, total, priceStyle, adult, room, child } = this.calculatePrice();
        let night = '';
        if (!isNull(this.props.initialFilter) && !isNull(this.props.initialFilter.stay)) {
            let checkIn = this.props.initialFilter.stay!.checkIn;
            let checkOut = this.props.initialFilter.stay!.checkOut;
            if (typeof checkIn === 'string') {
                checkIn = momentWrapper(checkIn);
            }
            if (typeof checkOut === 'string') {
                checkOut = momentWrapper(checkOut);
            }
            night = momentDuration(checkOut.diff(checkIn)).as('day').toFixed(0);
        }
        let htPriceMobile = (
            <div className='hotel-price mobile-only' style={{ margin: '0 1px', height: 170, position: 'relative', background: 'none' }}>
                <div className={`pointer-mobile offer ${cssDisc}`}>
                    <span style={{ fontSize: '0.6em', display: 'block' }}>Up to</span> {this.props.hotelData.discount}%  <span style={{ fontSize: '0.6em', display: 'block' }}>Off</span>
                </div>
                <div style={{ float: "right", display: 'block' }} >
                    <span className={cssDisc} style={{ textDecoration: 'line-through', color: '#d20300' }} >  {new FormatterUtils().formatMoney(total, this.props.currency, true, false)}</span>
                    <span className="price" style={priceStyle}> {new FormatterUtils().formatMoney(this.props.hotelData.minRate!, this.props.currency, true, false)}</span>

                </div>
                {room > 1 ? <p style={{ fontSize: "11px", width: '100%', float: 'right', textAlign: "right" }}> Lowest Price Option Per Room </p> : ""}
                <p className={` ${this.state.classright}`} style={{ fontSize: 18, color: '#444', float: "right", display: 'block', width: '100%', textAlign: 'right' }} >  {room} <i className='fa fa-bed' style={{ color: 'rgba(170, 0, 187, 0.74)' }} /> {adult} <i className='fa fa-user' style={{ color: 'rgba(170, 0, 187, 0.74)' }} />  {child} <i className='fa fa-child' style={{ color: 'rgba(170, 0, 187, 0.74)' }} />
                    <br /> <span style={{ fontSize: 12 }}>{this.props.hotelData.minPriceBoard} </span>
                </p>

                {btnWishlist}
                <i className={`fa fa-heart jantung ${wishlistAnimeClass}`} style={{ color: 'red', fontSize: 75 }} />
                <button
                    className={`btn-group btn form-control   ${showDetail === 'roomdetail' ? 'btn-info' : 'btn-danger'}`}
                    ref={d => { this.btnOption = d; }}
                    style={{ marginTop: '5px', bottom: 1, borderRadius: 0, width: '100%', left: 0, position: 'absolute', fontWeight: 800 }}
                    onClick={
                        () => {
                            console.log("Di CLick");
                            let showRoomDetail = !showRoomDetailstatu;
                            if (showRoomDetail) {
                                this.setState(
                                    {
                                        hotelDatas: <RoomAvailabilityList key={`RoomAvailabilityList${this.state.hotelData.reqAvailableDetailId!}`} lang={this.props.lang} reqKey={this.props.responKey} firebaseApp={this.props.firebaseApp} classright={this.state.classright} night={night} currencyCode={this.props.currency} reqAvailableDetailId={this.state.hotelData.reqAvailableDetailId!} history={this.props.history} />,
                                        showRoomDetailText: 'Hide Options',
                                        showRoomDetail, showDetail: 'roomdetail'
                                    }
                                );
                            } else if (this.state.showDetail === 'roomdetail') {
                                this.setState(
                                    {
                                        hotelDatas: <span />,
                                        showRoomDetailText: 'Choose Rooms',
                                        showRoomDetail, showDetail: 'price'
                                    }
                                );
                            }

                        }
                    }
                >
                    {showRoomDetailText}
                </button>
            </div>
        );
        if (this.state.minPrice === 10000000000) {
            htPriceMobile = (
                <div className='mobile-only' style={{ textAlign: 'center' }}>
                    <i className="ti-alarm-clock" style={{ fontSize: 32, color: '#ff0000' }} /> <br />
                    <h4 style={{ color: '#ff0000' }}><strong>You missed this deal <i className="ti-face-sad" /></strong><br /> These dates are really popular in Bali! </h4>
                </div>
            );
        }
        return htPriceMobile;
    }

    renderHotelMap = () => {
        let lat = this.props.hotelData.coordinates_latitude! / 1;
        let lng = this.props.hotelData.coordinates_longitude! / 1;
        return (
            <HotelMap defMapCenter={{ lat, lng }} hotelId={this.props.hotelId} />
        );
    }

    renderHotelImage = () => {
        return (
            <HotelImages hotelCode={this.props.hotelId} lang={this.props.lang} />
        );
    }
    renderHotelDetail = () => {
        return (
            <HotelDescription hotelCode={this.props.hotelId} lang={this.props.lang} />
        );
    }
    renderHotelReview = () => {
        return (
            <iframe style={{ height: '100vh' }} width="100%" frameBorder='0' src={`${TRIPADVISOR.WidgetEmbed}${this.props.hotelId}`} />
        );
    }
    renderMounthlySpecial = () => {
        return (
            <HotelMounthlySpecial lang={this.props.lang} />
        );
    }

    hengleUserDialogClose: () => any = () => {
        this.setState({ isOpen: false });
    }
    tripModelClosDialog: () => any = () => {
        this.setState({ tripmodelOpen: false });
    }
    hendlerRoomDetailClose: () => any = () => {
        this.setState({ roomDetailOpen: false });
    }
    wishlist: (hotel: HotelBedData.Hotel) => any = (hotel: HotelBedData.Hotel) => {
        console.log("Wishlist");

        let img = '';
        if (hotel.images && hotel.images!.length > 0) {
            img = hotel.images![0].thumb!;
            if (!img) {
                img = hotel.images![0].path!;
            }
        }
        let h: HotelBedData.Hotel = {
            code: hotel.code,
            name: hotel.name,
            // description: hotel.description,
            zoneName: hotel.zoneName,
            image: img,
            // latitude: hotel.latitude,
            // longitude: hotel.latitude,
            minRate: hotel.minRate,
            categoryCode: hotel.categoryCode,
            address: hotel.address,
            star: hotel.star
        };
        let wishlistID = sessionStorage.getItem(BHAM_STORAGE_WISHLIST) ? sessionStorage.getItem(BHAM_STORAGE_WISHLIST) : null;
        let RowData = [];
        let wwh = localStorage.getItem(LOCAL_STORAGE_KEY_WISHLIST);
        if (wwh) {
            let whs = JSON.parse(wwh);
            RowData = JSON.parse(whs.rowData);

        }
        RowData.push(JSON.stringify(h));
        let wishlistRequest: WishlistRequest = {
            filter: JSON.stringify(this.props.initialFilter),
            rowData: JSON.stringify(RowData),
            code: wishlistID,
            status: 'OPEN'
        };

        this.setStateHelper(
            st => {
                st.wishlistAnimeClass = 'jantung-terbang';
            },
            () => {
                getAjaxhelper().post("/dynamics/hb-api/cms-wishlist", wishlistRequest).then(d => {
                    localStorage.setItem(LOCAL_STORAGE_KEY_WISHLIST, JSON.stringify(d));
                    sessionStorage.setItem(BHAM_STORAGE_WISHLIST, d.code);
                    this.props.wishlistCount(1);
                    this.setState({ btnWishlist: <span />, wishlistAnimeClass: 'hide' });
                }).catch(exc => {
                    console.log(exc);
                });
            });
    }
    /**
     * handler kalau data hotel di terima
     */
    private onHotelDetailDataRecevied: (hotel: HotelBedData.Hotel) => any = (data: HotelBedData.Hotel) => {
        appendTranslations(this.props.lang, data.translations!);
        let a = localStorage.getItem(LOCAL_STORAGE_KEY_WISHLIST);
        this.setStateHelper(
            st => {
                st.image_url = data.image as any;
                st.images = data.images;
                st.hotelData = this.props.hotelData;
                st.hotelData.images = data.images;
                st.hotelData.facilities = data.facilities;
                st.hotelData.img_thumb = data.img_thumb;
                st.tripAdvisorData = data.TripAdvisorData;
                if (!isNull(a)) {
                    let wdata: WishlistStorageData = JSON.parse(a as string);
                    let j: string[] = JSON.parse(wdata.rowData);
                    for (let k of j) {
                        let l: HotelBedData.Hotel = JSON.parse(k);
                        if (l.code === st.hotelData.code) {
                            st.btnWishlist = <span />;
                        }
                    }
                }
            },
            () => {
                this.setStateHelper(
                    st => {
                        let indexRoomImages = {};
                        let indexRoomFacilities = {};
                        for (let addDataRooms of data.rooms as HotelBedData.Room[]) {
                            let code: any = addDataRooms.code;
                            indexRoomImages[code] = addDataRooms.images;
                            indexRoomFacilities[code] = addDataRooms.facilities;
                        }
                        if (typeof st.hotelData.rooms !== 'undefined') {
                            for (let idx of st.hotelData.rooms) {
                                let idxCode: any = idx.code;
                                idx.images = indexRoomImages[idxCode];
                                idx.facilities = indexRoomFacilities[idxCode];
                            }
                        }
                    }
                );
            }
        );
    }
} 


// WEBPACK FOOTER //
// ./src/hotels/HotelListPanelWithBulkData.tsx